export default __webpack_public_path__ + "static/media/firewall-outbound.d03bb270.svg";